import { Box } from '@mui/system'
import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import {
  Divider,
  MenuItem,
} from '@mui/material'
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded'
import { useDispatch } from 'react-redux'
import FinishModalContainer from '../../../components/Modals/FinishModalContainer.jsx'
import SideButtonContainerWithModal from '../../../components/Cards/helpers/SideButtonContainerWithModal'
import {
  updateTenantID,
  retrieveSystemAdminUsers,
  resetUserPasswordRequest,
  systemAdminUsersChangeStatus,
} from '../../../redux/features/users/SystemAdminUsers/SystemAdminUsersThunk'
import { ReactComponent as EditUserIcon } from '../../../images/editUser.svg'
import { ReactComponent as ResetPasswordIcon } from '../../../images/resetPassword.svg'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import { resetUserPasswordConfirmationData } from '../../../utils/confirmationDataContainer'
import ConfirmationModalContainerV2 from '../../../components/Modals/ConfirmationModalContainerV2.jsx'
import { SAML_KEY } from '../../../utils/constants'

const SysAdminUserActionBtn = ({ data, status, statusButtonList, route, customStyle }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = UseTranslation()
  const [confirmationModalState, setConfirmationModalState] = useState(false)
  const [finishModalState, setFinishModalState] = useState(false)
  const [confirmationData, setConfirmationData] = useState(null)
  const [confirmActionKind, setConfirmActionKind] = useState(null)

  const resetBtnObj = resetUserPasswordConfirmationData(t)

  const openResetPasswordConfirmation = () => {
    setConfirmActionKind('reset')
    setConfirmationData(resetBtnObj)
    setConfirmationModalState(true)
  }

  const openChangeStatusConfirmation = (statusItem) => {
    setConfirmActionKind('status')
    setConfirmationData(statusItem)
    setConfirmationModalState(true)
  }

  const handleNavigation = () => {
    history.push(route)

    dispatch(
      updateTenantID({
        queries: data?.company?.tenant?.id,
      }),
    )
  }

  const finishHandler = () => {
    dispatch(retrieveSystemAdminUsers({ resetQueries: true }))
    setFinishModalState(false)
  }

  const isSamlUser = data?.company?.sso_protocol === SAML_KEY

  return (
    <>
      <Box sx={[styles.root, customStyle && customStyle]}>
        <SideButtonContainerWithModal>
        <MenuItem onClick={() => handleNavigation()} sx={styles.option}>
        <EditUserIcon/>
          {`${t?.['Edit User Profile']}`}
        </MenuItem>

        {!isSamlUser && (
     <MenuItem onClick={() => openResetPasswordConfirmation()} sx={styles.option}>
        <ResetPasswordIcon/>
           {resetBtnObj.title}
            </MenuItem>
        )}

               <MenuItem disabled sx={styles.optionsTitle}>
                      {`${t?.['Change Status To']}`}
            </MenuItem>

            <Divider sx={styles.optionDivider} />
        {statusButtonList
          ?.filter((item) => item.title !== status?.title)
          .map((item, index) => (
                        <MenuItem
                          key={index}
                          onClick={() => openChangeStatusConfirmation(item)}
                          sx={styles.statusOption}>
                          <FiberManualRecordRoundedIcon style={{ fill: `${item.color}` }} />
                          {t?.[item.title]}
                        </MenuItem>
          ))}
        </SideButtonContainerWithModal>
      </Box>

      <ConfirmationModalContainerV2
        modalState={confirmationModalState}
        setModalState={setConfirmationModalState}
        actionAfterSuccess={() => setFinishModalState(true)}
        modalData={confirmationData}
        actionToDispatch={
          confirmActionKind === 'reset'
            ? resetUserPasswordRequest
            : systemAdminUsersChangeStatus
        }
        actionQueries={
          confirmActionKind === 'reset'
            ? { data }
            : { title: confirmationData?.title, data }
        }
      />
      <FinishModalContainer
        modalState={finishModalState}
        modalChangeState={setFinishModalState}
        modalTitle={confirmationData?.header || confirmationData?.title}
        modalMessage={confirmationData?.finish}
        finishHandler={finishHandler}
      />
    </>
  )
}

const styles = {
  optionDivider: {
    height: '1px',
    margin: { xs: '6px', sm: '8px 16px' },
    borderRadius: '12px',
    backgroundColor: '#eaeaea',
  },
  optionsTitle: {
    fontFamily: 'Avenir',
    fontSize: { xs: '10px', sm: '14px' },
    textTransform: 'capitalize',
    minHeight: { xs: '30px', sm: '48px' },
  },
  option: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: { xs: '10px', sm: '10px 15px' },
    margin: '0px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
    gap: '10px',
    fontSize: { xs: '13px', sm: '14px' },
    fontFamily: 'Avenir, Roboto, monospace',
    '& svg:first-of-type': {
      display: { xs: 'flex', sm: 'none' },
      filter: 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)',
      width: '20px',
      height: '20px',
    },
  },
  statusOption: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    cursor: 'pointer',
    padding: { xs: '10px', sm: '10px 15px' },
    margin: '0px',
    '&:hover': {
      backgroundColor: '#f7f9fb',
    },
    gap: '10px',
    fontSize: { xs: '13px', sm: '14px' },
    fontFamily: 'Avenir, Roboto, monospace',
    '& .MuiSvgIcon-root': {
      marginRight: { xs: '4px', sm: '7px' },
      width: { xs: '16px', sm: '1em' },
      height: { xs: '16px', sm: '1em' },
    },
    '& svg:first-of-type': {
      width: '20px',
      height: '20px',
    },
  },
}

export default SysAdminUserActionBtn
